module.exports = __webpack_public_path__ + "img/ce95b727cd4dddb28f8e2f0144c88a9f.0a8add0e.png";